// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jeI8N","rightAdornment":"Header_rightAdornment__mrrGQ"};